import { NotificationTypes } from './enums';
import { EntityTypes } from './enums/entityTypes';

export interface SystemNotification {
  notificationId: string;
  orgId: string;
  userId?: string;
  recordId?: string;
  entityType: EntityTypes.systemNotification;
  recordURL?: string;
  notificationType: NotificationTypes;
  secondaryOrg?: string;
  systemMessage: string;
  viewed: boolean;
  acknowledged: boolean;
  created: number;
  lastUpdated: number;
}

export interface SystemNotificationItem
  extends Omit<SystemNotification, 'notificationId'> {
  PK: string;
  notificationId?: string;
}
